import { responseStatus, useHandleRequest } from "../service/api-services";
import { getDefaultQuery } from "../utils/query-client";

export const mediasQueries = {
    EDIT: "MEDIAS_EDIT",
    CREATE: "MEDIAS_CREATE",
    DELETE: "MEDIAS_DELETE",
    GET_ALL: "MEDIAS_GET_ALL",
    GET_BY_ID: "MEDIAS_GET_BY_ID",
}


export function useMediasService() {

    const handleRequest = useHandleRequest();

    async function createMedias({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/media`, 'POST', payload);
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function editMedias({ payload, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/media/${payload.id}`, 'PUT', payload);
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function deleteMedias({ id, onSuccess }) {
        const { status, data } = await handleRequest.handleRequest(`/media/${id}`, 'DELETE');
        if (status === responseStatus.SUCCESS) {
            if (onSuccess) {
                onSuccess(data);
            }
        }
    }

    async function getAllMedias({ search, page }) {
        const filters = [{ search }];
        let query = getDefaultQuery({ page, filters });
        const { status, data } = await handleRequest.handleRequest(`/media/${query}`, 'GET');
        if (status === responseStatus.SUCCESS) {
            return data;
        }
    }

    async function getMediasById({ id }) {
        if (id) {
            const { status, data } = await handleRequest.handleRequest(`/media/${id}`, 'GET');
            if (status === responseStatus.SUCCESS) {
                return data;
            }
        }
    }

    return {
        createMedias,
        editMedias,
        deleteMedias,
        getAllMedias,
        getMediasById,
    }
}
